'use strict';
import LalamoveResource from '../LalamoveResource';
import resourceMethod from '../Method';
export default LalamoveResource.extend({
    create: resourceMethod({
        method: 'POST',
        path: 'orders',
    }),
    retrieve: resourceMethod({
        method: 'GET',
        path: 'orders/{orderId}',
    }),
    retrieveDriverDetails: resourceMethod({
        method: 'GET',
        path: 'orders/{orderId}/drivers/{driverId}',
    }),
    retrieveDriverLocation: resourceMethod({
        method: 'GET',
        path: 'orders/{orderId}/drivers/{driverId}/location',
    }),
    cancel: resourceMethod({
        method: 'PUT',
        path: 'orders/{id}/cancel',
    }),
    addPriorityFee: resourceMethod({
        method: 'PUT',
        path: 'orders/{id}/tips',
    }),
});
//# sourceMappingURL=Orders.js.map